"use client";

import { useEffect, useSyncExternalStore } from "react";
import {
  getServerVisibleFloatingSurfaces,
  getVisibleFloatingSurfaces,
  setFloatingSurfaceVisible,
  subscribeFloatingSurfaces,
} from "@/utils/common/floatingSurfaces";

export function useFloatingSurfaceVisibility(id: string, isVisible: boolean): void {
  useEffect(() => {
    setFloatingSurfaceVisible(id, isVisible);
    return () => setFloatingSurfaceVisible(id, false);
  }, [id, isVisible]);
}

export function useAnyFloatingSurfaceVisible(): boolean {
  const visible = useSyncExternalStore(
    subscribeFloatingSurfaces,
    getVisibleFloatingSurfaces,
    getServerVisibleFloatingSurfaces
  );
  return visible.length > 0;
}
